import styled from 'styled-components';

const SwitchWrapper = styled.label`
  position: relative;
  display: inline-block;
  width: 35px;
  height: 20px;
`;

const SwitchSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  border-radius: 34px;
  transition: 0.4s;
  border: 2px solid #dde0e6;
  box-shadow: 0px 2px 5px 0px #26334d08;

  &:before {
    position: absolute;
    content: '';
    height: 15px;
    width: 15px;
    left: 1.5px;
    bottom: 0.5px;
    background-color: #3361ff;
    border-radius: 50%;
    transition: 0.4s;
  }
`;

const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + ${SwitchSlider} {
    background-color: #3361ff;
    border: 2px solid #3361ff;
    box-shadow: 0px 2px 5px 0px #3361ff33;
  }

  &:checked + ${SwitchSlider}:before {
    transform: translateX(15px);
    background-color: white;
  }
`;

export { SwitchSlider, SwitchInput, SwitchWrapper };
